export const MARKET_RATE_STATUSES = {
  DELIVERED: 'delivered',
  IN_TRANSIT: 'in_transit',
  PICKED_UP: 'picked_up',
  DISPATCHED: 'dispatched',
  CANCELED: 'canceled',
  LISTED: 'listed',
} as const

export type MarketRateStatus =
  (typeof MARKET_RATE_STATUSES)[keyof typeof MARKET_RATE_STATUSES]

export interface MarketRateStats {
  low: number
  lowPerMi?: number
  recommended: number
  recommendedPerMi?: number
  high: number
  highPerMi?: number
  sampleSize?: number
  referenceDistanceMi?: number
  /** Provider confidence, 0–100. Only Super Dispatch returns this. */
  confidence?: number
}

export interface MarketRateRow {
  id: string
  vehicleType: string
  origin: string
  destination: string
  externalUrl?: string
  distanceMi?: number
  listedDate?: string
  listedPrice: number
  listedPricePerMi: number
  status: MarketRateStatus
  statusLabel?: string
  dispatchedDate?: string
  actualPrice?: number
  actualPricePerMi?: number
}
